import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { TimePicker } from 'antd';
import DatePicker from '../../Input/DatePicker';
import styles from './styles.less';

const StartDate = ({ updateContent, day, time, t, schedules }) => {
  const format = 'HH:mm';

  React.useEffect(() => {
    if (day && time) {
      let schedule = {};
      if (schedules && schedules[0]) {
        schedule = { ...schedules[0] };
      }
      schedule.start_date = day;
      schedule.custom_daytime = time;
      schedule.duration_type = 'day';
      updateContent('schedules', [schedule]);
    }
    if (schedules && schedules[0] && schedules[0].custom_daytime) {
      if (!day) {
        updateContent('day', schedules[0].start_date);
      }
      if (!time) {
        updateContent('time', schedules[0].custom_daytime);
      }
    }
  }, [day, time]);

  return (
    <div className={styles.datepicker} name="wizard_day_time">
      <DatePicker
        onChange={momentDate => updateContent('day', momentDate || moment())}
        placeholder={t('wizard.day')}
        name="wizard_day"
        value={schedules && schedules[0] && moment(schedules[0].start_date, 'YYYY-MM-DD')}
      />
      <TimePicker
        onChange={momentDate => updateContent('time', momentDate || moment())}
        format={format}
        placeholder={t('wizard.time')}
        name="wizard_time"
        value={schedules && schedules[0] && moment(schedules[0].custom_daytime, 'HH:mm')}
      />
    </div>
  );
};

StartDate.propTypes = {
  updateContent: PropTypes.func,
  t: PropTypes.func,
  day: PropTypes.object,
  time: PropTypes.object,
  schedules: PropTypes.array,
};

StartDate.defaultProps = {
  updateContent: () => {},
  day: {},
  time: {},
  t: () => {},
  schedules: [],
};

export default StartDate;
